import { GET_ALL_FINS_SUCCESS, GET_ALL_FINS_FAIL, LOGOUT, GET_ALL_FINS_REQUEST } from "../actions/types";

const initialState = { finances: null, loading: false, error: null };

export const getAllFinancesReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_ALL_FINS_REQUEST:
      return {
        ...state,

        finances: null,
        loading: true,
      };
    case GET_ALL_FINS_SUCCESS:
      return {
        ...state,
        finances: payload,
        loading: false,
      };
    case GET_ALL_FINS_FAIL:
      return {
        ...state,
        finances: [],
        error: payload,
        loading: false,
      };
    // case LOGOUT:
    //   return {
    //     ...state,
    //     customers: false,
    //     user: null,
    //   };
    default:
      return state;
  }
};
